import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { setNoteDisplayDialog, toggleContactNoteDrawer } from 'reducers/contactNoteListReducer';
import { GlobalState } from 'reducers/stateTypes';
import CreateNewEntityButton from 'components/Common/CreateNewEntityButton';
import CssBaseline from '@mui/material/CssBaseline';
import { JBColors, JBIcon } from '@juliusbaer-gcrm/gcrm-frontend-components';
import { DisplayDialogs } from 'views/ContactNotes/ContactNotesContainer';

/**
 * Component to display the Contact Note action buttons (New Contact Note)
 */
const ContactNoteSelect = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: GlobalState) => state.user.userDetails);
  const { t } = useTranslation();

  const onClick = () => {
    dispatch(toggleContactNoteDrawer(true));
    dispatch(setNoteDisplayDialog(DisplayDialogs.NEW_NOTE_VIEW));
  };

  return (
    <div>
      <CssBaseline />
      <CreateNewEntityButton
        buttonText={t('notecreation.button.action', 'Create')}
        disabled={!user.hasNoteCreationAccess}
        id="note-select-new-note-button"
        testId="create-note-button"
        buttonAction={() => onClick()}
        icon={<JBIcon iconName="contactNote" size="xxxl" fill={JBColors.core.reflexBlue[100]} />}
        description={t('notecreation.button.description', 'New contact note')}
        isLoading={false}
      />
    </div>
  );
};

export default ContactNoteSelect;
